// @ts-expect-error untyped
import ALLOY from 'bender-url!../../assets/voice-samples/alloy.mp3';
// @ts-expect-error untyped
import ECHO from 'bender-url!../../assets/voice-samples/echo.mp3';
// @ts-expect-error untyped
import FABLE from 'bender-url!../../assets/voice-samples/fable.mp3';
// @ts-expect-error untyped
import NOVA from 'bender-url!../../assets/voice-samples/nova.mp3';
// @ts-expect-error untyped
import ONYX from 'bender-url!../../assets/voice-samples/onyx.mp3';
// @ts-expect-error untyped
import SHIMMER from 'bender-url!../../assets/voice-samples/shimmer.mp3';
export default {
  ALLOY,
  ECHO,
  FABLE,
  NOVA,
  ONYX,
  SHIMMER
};